import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
	SaveAndContinueLaterDialogComponent,
	SaveAndContinueLaterDialogData,
	SaveAndContinueLaterResult
} from './save-and-continue-later-dialog.component';

@Injectable({ providedIn: 'root' })
export class SaveAndContinueLaterDialogService {
	constructor(private readonly modalService: TlkModalWindowService) {}

	open(integratorName: string): Observable<SaveAndContinueLaterResult> {
		const dialogRef = this.modalService.open<
			SaveAndContinueLaterResult,
			SaveAndContinueLaterDialogData,
			SaveAndContinueLaterDialogComponent
		>(SaveAndContinueLaterDialogComponent, { data: { name: integratorName } });

		return dialogRef.closed.pipe(map(result => result ?? null));
	}
}
